import * as React from 'react';
import { SimpleForm, Toolbar as T, useUpdate, useNotify, useRefresh, useRecordContext } from 'react-admin';
import { Grid } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { ChildFormFields, Resource, DEACTIVATION_LABELS, NOTIFICATION_OPTIONS_SUCCESS } from 'src/constants';
import {
    ShsButton,
    ShsSaveButton,
    ShsDatePicker,
    WithRole,
    ShsDeactivateConfirmDialog,
    ShsSuccessNotification
} from 'src/components/common';
import { MIN_SERVICE_END_DATE, TODAY } from 'src/constants/children/form';
import { UserRole } from 'src/auth/types';

const styles = {
    '&.MuiCardContent-root, &.MuiToolbar-root': {
        display: 'inline-block',
        p: 0,
        m: 0,
        mt: 0.4
    },
    '&.MuiToolbar-root .MuiButtonBase-root': {
        mt: '-2px'
    }
};

const Toolbar: React.FC = () => {
    return (
        <T sx={styles} className="add-child-toolbar">
            <ShsSaveButton label="Деактивувати" sx={{ height: '45px', ml: 2 }} />
        </T>
    );
};

export const ServiceEndDate: React.FC = () => {
    const refresh = useRefresh();
    const [newServiceEndDate, setNewServiceEndDate] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [pendingData, setPendingData] = React.useState<any>(null);
    const [update] = useUpdate();
    const notify = useNotify();
    const record = useRecordContext();
    const formPath = 'ServiceEndDate';

    const handleConfirm = () => {
        if (!pendingData) return;

        const payload = {
            id: pendingData.id,
            date: pendingData[formPath][ChildFormFields.EDUCATIONAL_SERVICE_END]
        };
        update(
            Resource.CHILDREN,
            {
                id: pendingData.id,
                data: payload,
                meta: { useMock: false, method: `end-service-date` }
            },
            {
                mutationMode: 'optimistic',
                onSuccess: () => {
                    setNewServiceEndDate(true);
                    setConfirmOpen(false);
                    setPendingData(null);
                    refresh();
                    notify(<ShsSuccessNotification message="Дані збережено" />, {
                        ...NOTIFICATION_OPTIONS_SUCCESS,
                        undoable: true
                    });
                },
                onError: (error: any) => {
                    setNewServiceEndDate(false);
                    setConfirmOpen(false);
                    setPendingData(null);
                    notify(`Error: ${error?.message}`, { type: 'warning', undoable: true });
                }
            }
        );
    };

    const handleSubmit = (data: any) => {
        setPendingData(data);
        setConfirmOpen(true);
    };

    const handleClose = () => {
        setConfirmOpen(false);
        setPendingData(null);
        setNewServiceEndDate(false);
    };

    const childName = record
        ? `${record.lastName || ''} ${record.firstName || ''} ${record.patronymic || ''}`.trim()
        : '';

    return (
        <Grid item xs={12}>
            {newServiceEndDate ? (
                <>
                    <SimpleForm sx={styles} toolbar={<Toolbar />} onSubmit={handleSubmit}>
                        <WithRole roles={[UserRole.SYSTEM_ADMIN]}>
                            <ShsDatePicker
                                source={`${formPath}.${ChildFormFields.EDUCATIONAL_SERVICE_END}`}
                                label=""
                                required
                                maxDate={TODAY}
                            />
                        </WithRole>
                        <WithRole roles={[UserRole.ADMIN, UserRole.METHODOLOGIST, UserRole.SECRETARIAT]}>
                            <ShsDatePicker
                                source={`${formPath}.${ChildFormFields.EDUCATIONAL_SERVICE_END}`}
                                label=""
                                required
                                minDate={MIN_SERVICE_END_DATE}
                                maxDate={TODAY}
                            />
                        </WithRole>
                    </SimpleForm>
                    <ShsDeactivateConfirmDialog
                        open={confirmOpen}
                        onClose={handleClose}
                        onConfirm={handleConfirm}
                        title={DEACTIVATION_LABELS.CHILD.TITLE}
                        confirmLabel={DEACTIVATION_LABELS.CHILD.CONFIRM}
                        cancelLabel={DEACTIVATION_LABELS.CHILD.CANCEL}>
                        Чи впевнені ви що хочете деактивувати {childName}?
                        <br />
                        <br />
                        {DEACTIVATION_LABELS.CHILD.BODY_SUFFIX}
                    </ShsDeactivateConfirmDialog>
                </>
            ) : (
                <ShsButton
                    styleType="round"
                    label="Додати"
                    icon={<AddCircleOutlineIcon />}
                    sx={{ height: '24px', border: 'none !important', p: '0 !important', mt: '-5px' }}
                    onClick={() => setNewServiceEndDate(true)}
                />
            )}
        </Grid>
    );
};

export default ServiceEndDate;
